import * as Yup from "yup";

export const validateModel = Yup.object().shape({
  planSalud: Yup.string().required("Campo obligatorio"),
  urgencias: Yup.string().required("Campo obligatorio"),
  tramites: Yup.string().required("Campo obligatorio"),
});
